import React, { useState } from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import env from "../../../config/env"

const DeleteChatModal = ({ isOpen, onClose, id, fetchChats, navigateBack }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BASE_URL = `${env.API_URL}/v1`;

  const handleDeleteClick = async () => {
    setLoading(true);
    const response = await axios.get(`${BASE_URL}/chat/delete?id=${id}`);
    if (response?.data?.success) {
      navigateBack && navigate("/app/chat");
      fetchChats();
      onClose();
    }
  };
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      showAlert={false}
      title={
        <p className="text-center text-[18px] font-bold font-Inter">
          Delete Chat
        </p>
      }
    >
      <p className="text-[14px] text-[#2C2C2C] font-[600] font-Inter">
        You're about to delete this chat. This action is permanent and cannot be
        undone.
      </p>
      <div className="mt-5 flex items-center justify-end gap-3">
        <Button
          className="!bg-[#FEE9E7] !text-[#C00F0C]"
          sx={{ border: "1px solid #FEE9E7" }}
          onClick={() => handleDeleteClick()}
          disabled={loading}
        >
          Delete
        </Button>
        <Button
          className="!bg-white !text-black"
          sx={{ border: "1px solid black" }}
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </CommonModal>
  );
};

export default DeleteChatModal;
